import React, { ChangeEvent } from "react";

import { sanitizeInput } from "src/organization/pages/project/ManageBackupSchedulePage/util";

import * as S from "./IntervalNumInput.styles";
type IntervalNumInputProps = {
  id: string;
  value: string | number;
  placeholder?: string;
  onBlur: (value: number) => void;
  onChange: (value: number) => void;
  isValid: boolean;
  width?: string;
};

const IntervalNumInput = ({
  id,
  value,
  placeholder,
  onBlur,
  onChange,
  isValid,
  width
}: IntervalNumInputProps) => {
  const handleBlur = (e: ChangeEvent<HTMLInputElement>) => {
    const value = sanitizeInput(e.currentTarget.value);
    onBlur(isNaN(value) || value < 1 ? 1 : value);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = sanitizeInput(e.currentTarget.value);
    onChange(isNaN(value) ? 0 : value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const key = e.key;
    let value = sanitizeInput(e.currentTarget.value);

    value = isNaN(value) ? 0 : value;

    if (key === "ArrowDown") {
      onChange(value < 1 ? 0 : value - 1);
    } else if (key === "ArrowUp") {
      onChange(value + 1);
    }
  };

  return (
    <S.IntervalNumInput
      id={id}
      analyticId={placeholder}
      value={value}
      placeholder={placeholder}
      onBlur={handleBlur}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      type="text"
      isValid={isValid}
      width={width}
    />
  );
};

export default IntervalNumInput;
